<template lang="pug">
v-container(fluid)
  h1 Обработанные письма
  v-row.mt-2
    v-col(cols="4")
      select-my-user(
        v-model="searchKeys.user_id"
        hide-details
        dense outlined
        multiple
        @input="runSearch"
      )
    v-col(cols="4")
      select-project(
        v-model="searchKeys.project_id"
        placeholder="Проект"

        outlined
        multiple
        hide-details
        dense
        clearable
        @input="runSearch"
      )
    //- v-col
    //-   select-template-category(
    //-     :menu-props="{ auto: true }"
    //-     v-model="searchKeys.question_category_id"
    //-     @input="runSearch"
    //-     dense outlined
    //-     label='Категория'
    //-   )
    v-col(cols="4")
      select-region(
        v-model="searchKeys.region_id"
        dense outlined
        @input="runSearch"
        hide-details
        label="Регион"
      )
    v-col(cols="4")
      DatePicker(
        v-model="searchKeys.date_start"
        label="Дата начала"
        dense outlined
        hide-details
        @change="runSearch"
      )
    v-col(cols="4")
      DatePicker(
        v-model="searchKeys.date_stop"
        label="Дата окончания"
        hide-details
        dense outlined
        @change="runSearch"
      )
    v-col(cols=4)
      v-checkbox(
        v-model="searchKeys.parent_id"
        label="Привязанные к technical_support "
        value='3'
        false-value=null
        @change="runSearch"
      )
  smart-table(
    :headers="headers"
    :adapter="adapter"
    hide-search-actions
    hide-expand
    :needToUpdateTable="needToUpdateTable"
  )

</template>
<script>
import service from '@/services/API/export';
import SelectProject from '@/components/inputs/SelectProject.vue';
import SmartTable from '@/components/SmartTable/index.vue';
import SelectMyUser from '@/components/inputs/SelectMyUser.vue';
import SelectTemplateCategory from '@/components/inputs/SelectTemplateCategory.vue';
import SelectRegion from '@/components/inputs/SelectRegion.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';

export default {
  name: 'AutoAnsewerSettings',
  components: {
    SelectProject,
    SmartTable,
    SelectMyUser,
    SelectTemplateCategory,
    SelectRegion,
    DatePicker,
  },
  data() {
    return {
      menu: false,
      date: null,
      needToUpdateTable: false,
      searchKeys: {
        parent_id: null,
      },
      headers: [
        // {
        //   text: '',
        //   value: 'view',
        // },
        {
          text: 'Пользователь',
          value: 'username',
        },
        {
          text: 'Все',
          value: 'all',
        },
        {
          text: 'Подтвержденные',
          value: 'accepted',
        },
        {
          text: 'Отвеченные',
          value: 'answered',
        },
        {
          text: 'Ожидание',
          value: 'awaiting',
        },
        {
          text: 'Ожидают',
          value: 'pending',
        },
        {
          text: 'Закрыты',
          value: 'closed',
        },
        {
          text: 'Удалены',
          value: 'deleted',
        },
        {
          text: 'help_question',
          value: 'help_question',
        },
      ],
    };
  },

  methods: {
    runSearch() {
      this.needToUpdateTable = true;
    },
    adapter(params) {
      this.needToUpdateTable = false;
      const exteded = {
        ...params,
        ...this.searchKeys,
      };
      return service.getExports(exteded);
    },
  },
};
</script>
